import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { LugaresService } from '../services/lugares.service';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import 'rxjs/Rx';
import { FormControl } from '@angular/forms';
import {Http, Headers} from "@angular/http";
declare var $:any;
declare var jquery:any;

@Component({
  selector: 'app-crear',
  templateUrl: './crear.component.html',
  styleUrls: ['./crear.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CrearComponent {

	lugar:any = {};
  id:any = null;
  result$: Observable<any>;
  private searchField: FormControl;

  constructor(private route: ActivatedRoute, private LugaresService: LugaresService, private http: Http ) {
    this.id = this.route.snapshot.params['id'];
    if(this.id != 'new') {
      this.LugaresService.getLugar(this.id)
        .valueChanges().subscribe((lugar)=> {
          this.lugar = lugar;
        });
    }
    const URL = 'http://maps.google.com/maps/api/geocode/json';
    this.searchField = new FormControl();
    this.result$ = this.searchField.valueChanges
      .debounceTime(350)
      .switchMap(query=> this.http.get(`${URL}?address=${query}`))
      .map(response => response.json())
      .map(response => response.results);
  }

seleccionarDireccion(result) {
    const addressComponents = result.address_components
    const adrressParams: any = {}
    for (let i = 0, len = addressComponents.length; i < len; i++) {
      const type = addressComponents[i].types[0].toString()
      switch (type) {
        case'street_number':
          adrressParams.street_number = addressComponents[i].long_name
          break
        case'route':
          adrressParams.route = addressComponents[i].long_name
          break
        case'locality':
          adrressParams.locality = addressComponents[i].long_name
          break
        case'country':
          adrressParams.country = addressComponents[i].long_name
          break
      }
    }
    this.lugar.calle = `${adrressParams.route}${adrressParams.street_number}`
    this.lugar.ciudad = adrressParams.locality
    this.lugar.pais = adrressParams.country
  }
	guardarLugar(){
  var direccion = `${this.lugar.calle} , ${this.lugar.ciudad} , ${this.lugar.pais}`;
  this.LugaresService.obtenerGeoData(direccion).subscribe(result => {
    
      this.lugar.lat = result.json().results[0].geometry.location.lat;
      this.lugar.lng = result.json().results[0].geometry.location.lng;

      

        if(this.id != 'new') {
          this.LugaresService.editarLugar(this.lugar);
          alert('Negocio Actualizado con Exito');
        } else {

      this.LugaresService.guardarLugar(this.lugar);
          this.lugar.id = Date.now();
        alert('Negocio Guardado con Exito');
        }
      
      this.lugar = {};
  })

	}

ngOnInit(){

}


}



// WEBPACK FOOTER //
// C:/Users/Domin/OneDrive/Proyectos/GyCPlaza/src/app/crear/crear.component.ts